<template>
    <div class="financeApplication__form">
        <ValidationObserver ref="observer">
            <div :class="classNames">
                <ValidationProvider
                    name="mobile number"
                    :rules="mobileValidationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="mobileNumber"
                        label="Mobile Number"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            type="tel"
                            id="mobileNumber"
                            placeholder="Enter Mobile Number"
                            v-model="mobileNumber"
                            @change="onChange({ key: 'mobileNumber', value: $event })"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>

                <ValidationProvider
                    name="email"
                    :rules="emailValidationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="emailAddress"
                        label="Email Address"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            type="email"
                            id="emailAddress"
                            placeholder="Enter Email Address"
                            v-model="emailAddress"
                            @change="onChange({ key: 'emailAddress', value: $event })"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>

                <FinanceApplicationRow>
                    <div class="financeApplication__form__inputCheckbox">
                        <input type="checkbox"
                               id="marketing"
                               v-model="marketingAgreement"
                        />
                        <label for="marketing">I consent to receive electronic marketing from us with our other deals & offers</label>
                    </div>
                </FinanceApplicationRow>

                <ValidationProvider
                    name="terms"
                    :rules="termsValidationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        :error-message="errors[0]"
                    >
                        <div class="financeApplication__form__inputCheckbox">
                            <input type="checkbox"
                                   id="terms"
                                   name="terms"
                                   :value="true"
                                   v-model="termsAgreement"
                            />
                            <label for="terms">By submitting your application, I agree to the <a href="https://www.petervardy.com/customer-services/terms" target="_blank">terms and conditions</a> and <a href="https://www.petervardy.com/customer-services/cookies-and-privacy" target="_blank">privacy policy</a>.</label>
                        </div>
                    </FinanceApplicationRow>
                </ValidationProvider>

            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FinanceApplicationText from './FinanceApplicationText.vue'
import FinanceApplicationRow from './FinanceApplicationRow.vue'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        FinanceApplicationRow,
        FinanceApplicationText,
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number
        }
    },
    data() {
        return {
            mobileNumber: this.initialValues.mobileNumber,
            emailAddress: this.initialValues.emailAddress,
            termsAgreement: this.initialValues.termsAgreement,
            marketingAgreement: this.initialValues.marketingAgreement,
        }
    },
    methods: {
        async onChange({ key, value }) {
            this.$emit('change', { key, value })

            let valid = await this.$refs.observer.validate()

            // vee-validate checkbox validation sucks for ValidationProvider, so hacking in our own
            if (key === 'termsAgreement' && value === false) {
                valid = false

            }

            this.$emit('validate', { key: 'contact', valid })
        }
    },
    watch: {
        mobileNumber(value) {
            this.onChange({
                key: 'mobileNumber',
                value
            })
        },
        emailAddress(value) {
            this.onChange({
                key: 'emailAddress',
                value
            })
        },
        termsAgreement(value) {
            this.onChange({
                key: 'termsAgreement',
                value
            })
        },
        marketingAgreement(value) {
            this.onChange({
                key: 'marketingAgreement',
                value
            })
        },
    },
    computed: {
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 670) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        mobileValidationRules() {
            return {
                required: true,
            }
        },
        emailValidationRules() {
            return {
                required: true,
                email: true
            }
        },
        termsValidationRules() {
            return  {
                required: 'invalidateFalse',
            }
        }
    }
}
</script>